import React from 'react';

/**
 * AcmeLogo — placeholder wordmark for the Acme Industries demo tenant.
 *
 * When PIE moves out of prototype, this component will be swapped for
 * a generic `<OrgLogo src={org.logo_url} alt={org.name} />` so each
 * tenant brings its own brand. Until then, the demo displays this
 * cleanly-styled "ACME INDUSTRIES" mark so the prototype feels like
 * a real org's app, not a generic shell.
 */
export default function AcmeLogo({ height = 28, ...rest }) {
  return (
    <svg
      viewBox="0 0 220 40"
      height={height}
      role="img"
      aria-label="Acme Industries"
      {...rest}
    >
      <defs>
        <linearGradient id="pie-acme-gradient" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#0F172A" />
          <stop offset="100%" stopColor="#1E293B" />
        </linearGradient>
      </defs>
      {/* Stylised hexagonal mark — premium industrial feel */}
      <g>
        <path
          d="M22 4 L36 12 L36 28 L22 36 L8 28 L8 12 Z"
          fill="url(#pie-acme-gradient)"
        />
        <path
          d="M22 12 L29 16 L29 24 L22 28 L15 24 L15 16 Z"
          fill="#06B6D4"
          opacity="0.94"
        />
      </g>
      {/* Wordmark */}
      <text
        x="50"
        y="20"
        fontFamily="Inter, system-ui, sans-serif"
        fontSize="14"
        fontWeight="700"
        letterSpacing="0.16em"
        fill="#0F172A"
      >
        ACME
      </text>
      <text
        x="50"
        y="34"
        fontFamily="Inter, system-ui, sans-serif"
        fontSize="9"
        fontWeight="500"
        letterSpacing="0.32em"
        fill="#64748B"
      >
        INDUSTRIES
      </text>
    </svg>
  );
}
